import ScheduleManagerIcon from './component'

export default ScheduleManagerIcon
